import React from 'react';
import { FileCheck, GraduationCap, Briefcase, Globe2, ArrowRight } from 'lucide-react';

const Services = () => {
  const features = [
    {
      icon: <FileCheck className="w-7 h-7" />,
      title: "Visa Assistance",
      description: "End-to-end visa processing for all categories - tourist, student, work, and PR visas",
      highlights: ["Document preparation", "Application tracking", "Interview coaching"],
      color: "from-blue-600 to-cyan-600"
    },
    {
      icon: <GraduationCap className="w-7 h-7" />,
      title: "Study Abroad",
      description: "University selection, admissions support, and scholarship guidance for top global institutions",
      highlights: ["Course selection", "SOP & LOR writing", "Scholarship assistance"],
      color: "from-indigo-600 to-purple-600"
    },
    {
      icon: <Briefcase className="w-7 h-7" />,
      title: "Job Placement",
      description: "Connect with international employers and secure work permits for your dream career abroad",
      highlights: ["Job matching", "Resume building", "Work permit processing"],
      color: "from-orange-500 to-red-500"
    },
    {
      icon: <Globe2 className="w-7 h-7" />,
      title: "Immigration Services",
      description: "Complete PR and citizenship application support with expert guidance throughout the process",
      highlights: ["PR applications", "Citizenship support", "Family sponsorship"],
      color: "from-green-500 to-teal-500"
    }
  ];

  return (
    <section id="services" className="py-24 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center space-x-2 bg-indigo-100 text-indigo-800 rounded-full px-4 py-2 mb-4">
            <span className="text-sm font-semibold">Our Expertise</span>
          </div>
          <h2 className="text-4xl sm:text-5xl font-bold mb-4 text-gray-900">
            Comprehensive Services for Your
            <span className="block text-indigo-700">
              International Journey
            </span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            From visa processing to settlement support, we handle every aspect of your abroad journey with expertise and care
          </p>
        </div>
        
        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature, index) => (
            <div key={index} className="group relative bg-white p-7 rounded-2xl border border-gray-200 hover:border-indigo-300 hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2">
              <div className={`bg-gradient-to-r ${feature.color} w-14 h-14 rounded-xl flex items-center justify-center mb-5 text-white shadow-lg group-hover:scale-110 transition`}>
                {feature.icon}
              </div>
              
              <h3 className="text-xl font-bold mb-3 text-gray-900 group-hover:text-indigo-700 transition">
                {feature.title}
              </h3>
              <p className="text-gray-600 mb-4 leading-relaxed">
                {feature.description}
              </p>
              
              <ul className="space-y-2 mb-4">
                {feature.highlights.map((highlight, hIndex) => (
                  <li key={hIndex} className="flex items-center text-sm text-gray-500">
                    <div className={`w-1.5 h-1.5 bg-gradient-to-r ${feature.color} rounded-full mr-2`}></div>
                    {highlight}
                  </li>
                ))}
              </ul>
              
              <a href="#contact" className="inline-flex items-center text-sm font-semibold text-indigo-700 hover:text-indigo-800 transition">
                Learn More
                <ArrowRight className="w-4 h-4 ml-1 group-hover:translate-x-1 transition" />
              </a>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="mt-16 text-center">
          <p className="text-gray-600 mb-6">
            Not sure which service you need? Our experts will guide you through the best path forward.
          </p>
          <button className="bg-indigo-700 hover:bg-indigo-800 text-white px-8 py-3 rounded-full font-semibold shadow-lg hover:shadow-xl transition transform hover:scale-105">
            Get Free Consultation
          </button>
        </div>
      </div>
    </section>
  );
};

export default Services;
